// eslint-disable-next-line hubspot-dev/no-confusing-browser-globals
export const getLocation = () => location;

// @ts-expect-error populated at runtime
export const getJasmine = () => window.jasmine;